import styled from "styled-components";
import { device } from "./Device";

export const NavLink = styled.a`
  color: white;
  text-decoration: none;
  cursor: pointer;
  transition: opacity 0.2s ease-in-out;

  &:hover {
    opacity: 75%;
  }

  @media ${device.mobileS} {
    display: none;
  }

  @media ${device.laptop} {
    display: flex;
    font-size: 2.5vh;
    font-weight: 700;
    letter-spacing: 0.1vw;
    margin-top: 2.1vh;
  }

  @media ${device.laptopL} {
    display: flex;
    font-size: 2.7vh;
    font-weight: 700;
    letter-spacing: 0.1vw;
    margin-top: 1.8vh;
  }

  @media ${device.desktop} {
    display: flex;
    font-size: 2.8vh;
    font-weight: 700;
    letter-spacing: 0.1vw;
    margin-top: 1.8vh;
  }
`;
